/* eslint-disable */
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Pages
import LandingPage       from './pages/LandingPage';
import DashboardOverview from './pages/DashboardOverview';
import ClientsPage       from './pages/ClientsPage';
import CasesPage         from './pages/CasesPage';
import PlaceholderPage   from './pages/PlaceholderPage';
import ChatBotPage       from './pages/ChatBotPage';
import BlogPage          from './pages/BlogPage';
import BlogDetailPage    from './pages/BlogDetailPage';
import BlogAdminPage     from './pages/BlogAdminPage';

// Dashboard layout (sidebar + topbar shell)
import DashboardLayout   from './components/dashboard/DashboardLayout';

// Shared context providers
import { ChatProvider }  from './context/ChatContext';
import { BlogProvider }  from './context/BlogContext';

function App() {
  return (
    <BlogProvider>
      <ChatProvider>
        <BrowserRouter>
          <Routes>
            {/* Public landing page */}
            <Route path="/" element={<LandingPage />} />

            {/* Full-screen AI Chatbot page */}
            <Route path="/chatbot" element={<ChatBotPage />} />

            {/* Public Blog */}
            <Route path="/blog"     element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />

            {/* Dashboard — all sub-pages share DashboardLayout */}
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index          element={<DashboardOverview />} />
              <Route path="clients"   element={<ClientsPage />} />
              <Route path="cases"     element={<CasesPage />} />
              <Route path="blog"      element={<BlogAdminPage />} />
              <Route path="documents" element={<PlaceholderPage title="Documents"  description="Upload, organize, and manage all legal documents for your cases and clients." />} />
              <Route path="calendar"  element={<PlaceholderPage title="Calendar"   description="Schedule hearings, consultations, and deadlines all in one place." />} />
              <Route path="messages"  element={<PlaceholderPage title="Messages"   description="Internal messaging and secure client communication hub." />} />
              <Route path="reports"   element={<PlaceholderPage title="Reports"    description="Generate financial, case performance, and billing reports." />} />
              <Route path="settings"  element={<PlaceholderPage title="Settings"   description="Configure firm details, user permissions, and system preferences." />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ChatProvider>
    </BlogProvider>
  );
}

export default App;
